module.exports = __webpack_public_path__ + "img/SX.7a0ecd4c.svg";